import { render } from "./DetalleCotizacion.vue?vue&type=template&id=43201093"
import script from "./DetalleCotizacion.vue?vue&type=script&lang=js"
export * from "./DetalleCotizacion.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\COSMI\\Desktop\\appwebantiguo\\vue-op-vanguardia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__